import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "../components/Footer";
import { Mail } from 'lucide-react';

export default function ContactUs({ isAuthenticated, setIsAuthenticated }) {
  // Token and authentication check
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setIsAuthenticated(false);
      return;
    }
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp * 1000 < Date.now()) throw new Error("expired");
    } catch {
      localStorage.removeItem("token");
      setIsAuthenticated(false);
      return;
    }
    fetch("/api/users-logic/me/", { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        if (!res.ok) {
          localStorage.removeItem("token");
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);
        }
      })
      .catch(() => {});
  }, [setIsAuthenticated]);

  const faqs = [
    { q: 'How do I file Form 2290?', a: 'To file the form, go to the File Form page and follow the step-by-step instructions.' },
    { q: 'How long does it take to receive Schedule 1?', a: 'You will typically receive Schedule 1 within 15 minutes after a successful payment.' },
    { q: 'Can I file without an EIN?', a: 'No, e-filing requires a valid EIN; SSNs are not accepted.' },
    { q: 'How can I update company details after filing?', a: 'Please contact our support at support@2290pay.org to request any updates. We will respond within 24–48 hours.' },
    { q: 'What should I do if payment fails?', a: 'Check that your payment details are correct and try again. If the issue persists, reach out to us.' }
  ];

  return (
    <div className="bg-white text-[#0F2C5E] flex flex-col min-h-screen font-sans">
      <Header isAuthenticated={isAuthenticated} />
      <main className="flex-grow px-4 py-14">
        <h2 className="text-xl sm:text-2xl font-bold mb-6 uppercase tracking-wide text-center">
          Contact Us
        </h2>
        <div className="max-w-3xl mx-auto space-y-6">
          <div className="flex items-center">
            <Mail size={24} className="mr-3 text-[#0F2C5E]" />
            <a href="mailto:support@2290pay.org" className="text-base hover:underline">
              support@2290pay.org
            </a>
          </div>
        </div>

        <section className="mt-10 max-w-3xl mx-auto">
          <h3 className="text-lg font-semibold mb-4">Frequently Asked Questions</h3>
          <div className="space-y-2">
            {faqs.map((item, i) => (
              <details key={i} className="border border-gray-300 rounded">
                <summary className="px-4 py-2 cursor-pointer font-medium bg-gray-50 hover:bg-gray-100">
                  {item.q}
                </summary>
                <p className="px-4 py-2 text-gray-700">{item.a}</p>
              </details>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
